<h1 mat-dialog-title>Rechnungen Bulk (KI)</h1>

<div mat-dialog-content class="bulk-upload-content">
    <div
        class="drop-zone"
        phitoDropFile
        (onFileDropped)="onFileDropped($event)"
        role="button"
        tabindex="0"
        (keydown.enter)="openFilePicker()"
        (keydown.space)="$event.preventDefault(); openFilePicker()"
    >
        <mat-icon class="drop-zone__icon">cloud_upload</mat-icon>
        <div class="drop-zone__title">PDFs hierher ziehen</div>
        <div class="drop-zone__hint">Mehrere Dateien auf einmal (Strg/Shift) oder Ordner per Drag &amp; Drop</div>
        <div class="drop-zone__formats">PDF / XML</div>
        <button mat-stroked-button type="button" color="primary" class="drop-zone__pick" (click)="openFilePicker()">
            Dateien auswählen…
        </button>
    </div>

    <input
        #fileInput
        type="file"
        multiple="multiple"
        accept=".pdf,.xml,application/pdf,application/xml,text/xml"
        style="display: none"
        (change)="onFileInputChange($event)"
    />

    <div class="file-list" *ngIf="files.length > 0">
        <div class="file-list__head">
            <strong>{{ files.length }} Datei(en)</strong>
            <button mat-button type="button" color="warn" (click)="clearFiles()">Alle entfernen</button>
        </div>
        <ul>
            <li *ngFor="let f of files; let i = index">
                <span class="file-list__name" [title]="f.name">{{ f.name }}</span>
                <button mat-icon-button type="button" aria-label="Entfernen" (click)="removeFile(i)">
                    <mat-icon>close</mat-icon>
                </button>
            </li>
        </ul>
    </div>
</div>

<div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">Abbrechen</button>
    <button mat-flat-button color="primary" type="button" [disabled]="files.length === 0" (click)="start()">
        {{ files.length }} in Warteschlange
    </button>
</div>
